const maxModifiedValue = {
  broker_fee: {
    rcp: 20,
    rcpwk: 20,
    rcphx: 5,
    rcngawk: 20,
    rcpcm: 20,
    rcpml: 10,
    mrp: 20,
    mrpcm: 20,
    mrpml: 10,
    pnoml: 10,
    mriml: 10,
    mrpwk: 20,
    rcgls: 8,
    mri: 20,
    prev: 20,
    associaton: 0
  },
  paperwork_fee: {
    rcp: 1999,
    rcpwk: 1999,
    rcpcm: 1999,
    rcpml: 1999,
    mrp: 1999,
    mrpcm: 1999,
    mrpml: 1999,
    mrpwk: 1999,
    mri: 1999,
    rcngawk: 500,
    rcphx: 500,
    pnoml: 200,
    mriml: 500,
    rcgls: 250,
    prev: 50,
    association: 1999
  },
  commission_fee: {
    rcp: 40,
    rcpwk: 40,
    rcphx: 40,
    rcpcm: 40,
    rcpml: 30,
    mriml: 30,
    pnoml: 30,
    mrp: 40,
    mrpcm: 40,
    mrpml: 40,
    mrpwk: 40,
    mri: 40,
    prev: 40,
    rcngawk: 20,
    rcgls: 20,
    association: 30
  },
  contribution_adjustment: {
    rcp: 10,
    rcpwk: 10,
    rcphx: 10,
    rcpcm: 10,
    mrp: 10,
    mrpcm: 10,
    mrpml: 10,
    mrpwk: 10,
    mri: 10,
    prev: 10,
    rcgnawk: 10,
    association: 0,
    rcpml: 0,
    rcgls: 0
  }
};

export { maxModifiedValue };
